'use es6';

import { getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { selectThemeVariantName, getThemePresetPreviewParams } from 'ContentEditorUI/redux/selectors/themeSelectors';
import { getIsDataAuthoringModeActive } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import { selectInstanceId } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import EditorConfigSingleton from 'ContentEditorUI/EditorConfigSingleton';
import { FEATURE_FLAGS } from 'ContentEditorUI/redux/constants';
import { getIsStagingV2 } from 'ContentEditorUI/redux/selectors/authSelectors';
export function getCssAssetsUrl(id) {
  return `content-editor-rendering/v1/internal/render/${id}/edit/css-assets`;
}
export const getStandardFetchCssRequestOptions = state => {
  const contentId = getContentModelId(state);
  const themeVariant = selectThemeVariantName(state);
  const isDataAuthoringModeActive = getIsDataAuthoringModeActive(state);
  const shouldUseBufferedThemeSettings = EditorConfigSingleton.getFeatureFlagOrDefault(FEATURE_FLAGS.universalThemeEditor, false);
  const themePresetParams = getThemePresetPreviewParams(state);
  let query = themeVariant ? {
    themeVariant
  } : {};
  if (isDataAuthoringModeActive) {
    const instanceId = selectInstanceId(state);
    if (instanceId) {
      query.hubdb_row_id = instanceId;
    }
  }
  if (shouldUseBufferedThemeSettings) {
    query.buffer_theme = true;
    query = Object.assign({}, query, themePresetParams);
  }
  if (getIsStagingV2(state)) {
    query.staging = true;
  }
  return {
    url: getCssAssetsUrl(contentId),
    query
  };
};